var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 100,
    viewBox: "0 0 268 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2C3.51955 12.9616 12.4815 25.6999 18.0615 31.9894C23.8278 38.4889 30.0566 43.8355 36.2363 49.3035C44.4924 56.6088 52.2653 64.6673 61.1316 70.2112C83.1037 83.9496 106.858 93.339 130.745 89.1587C145.91 86.5049 161.798 80.0174 175.675 70.1458C182.467 65.3148 194.418 57.0372 196.428 44.338C199.824 22.8837 176.463 23.2358 168.448 25.0637C159.946 27.0028 155.33 40.3388 156.697 53.289C157.543 61.2934 162.311 68.4736 165.616 74.3273C170.505 82.9877 175.694 89.3824 182.988 92.5562C209.758 104.206 238.885 93.9204 266 91.3801",
    stroke: "#3EAB36",
    strokeOpacity: 0.5,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "10 10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFive);
export default __webpack_public_path__ + "static/media/five.3165b6eaef230e81fb7c1b7eb60661fd.svg";
export { ForwardRef as ReactComponent };